
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map'
import { Mensaje } from 'app/domain/publico';

@Injectable()
export class MensajeService {

    constructor() {
    }

    public item = new Subject<Mensaje>();
    items = this.item.asObservable();

    enviarAlerta(mensaje: Mensaje) {
        this.item.next(mensaje);
    };

    getMessages(): Observable<Mensaje> {
        return this.items;
    }
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/modulo_compartido/mensaje/mensaje.service.ts